import { Product as ProductDto } from "../../../app/proxy/products";

export class Product {
  id: number;
  name: string;
  measure: string;
  description: string;

  constructor(dto: ProductDto) {
    Object.assign(this, dto);
  }
}
